import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LadipageComponent } from './components/ladipage/ladipage.component';
import { LadipageRoutingModule } from './ladipage-routing.module';
@NgModule({
  declarations: [
    LadipageComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    LadipageRoutingModule
  ],
  providers: []
})
export class LadipageModule { }
